import Button from '@berlitz/button'
import { H2 } from '@berlitz/globals'
import styled, { css } from 'styled-components'

import { radiusXxxl } from '@utils/constants'

export const StyledButton = styled(Button)`
  font-size: ${({ theme }) => theme.fontSize.xxs};
  padding: ${({ theme }) => `${theme.space.xs} ${theme.space.lg}`};
  color: ${({ theme }) => theme.palette.blue90};
  font-weight: ${({ theme }) => theme.fontWeight.bold};

  &:hover {
    background-color: ${({ theme }) => theme.palette.blue20};
  }
`

const SelectedDate = css`
  background-color: ${({ theme }) => theme.colors.brandPrimary};
  color: ${({ theme }) => theme.colors.brandPrimaryContrast};
  padding: ${({ theme }) => `${theme.space.xxs} ${theme.space.md}`};
  border-radius: ${({ theme }) => theme.space.md};
`

export const StyledH2 = styled(H2)<{ selected: boolean }>`
  margin-bottom: ${({ theme }) => theme.space.md};
  span {
    border-radius: ${radiusXxxl};
    padding: 0;
    background-color: transparent;
    color: ${({ theme }) => theme.palette.charcoal};
    ${({ selected }) => (selected ? SelectedDate : '')}
  }
`

export const SchedBox = styled.div`
  margin: ${({ theme }) => theme.space.lg} 0px;
  margin-bottom: ${({ theme }) => theme.space.xxxl};
`

export const GroupedLessons = styled.div<{ isGroup?: boolean }>`
  position: relative;
  ${({ isGroup }) =>
    isGroup
      ? css`
          padding: ${({ theme }) => theme.space.sm};
          background: ${({ theme }) => theme.palette.blue10};
          margin-bottom: ${({ theme }) => theme.space.md};
          border-radius: ${({ theme }) => theme.radius.md};
        `
      : ``};
`

export const LessonCount = styled.div<{ moreSiblingBtns?: boolean }>`
  border-radius: ${({ theme }) => theme.radius.sm};
  display: inline-block;
  padding: ${({ theme }) => `${theme.space.xs} ${theme.space.sm}`};
  border: ${({ theme }) => `1px solid ${theme.palette.blueGray50}`};
  margin-bottom: ${({ theme }) => theme.space.sm};

  ${({ moreSiblingBtns }) =>
    moreSiblingBtns
      ? css`
          margin-top: ${({ theme }) => theme.space.lg};
          @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
            margin-top: 0;
          }
        `
      : ``};
`

export const SelfTechCheckWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.space.sm};
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: inline-block;
    padding-left: ${({ theme }) => theme.space.sm};
  }
`

export const HeaderWrapper = styled.div`
  display: flex;

  .btns {
    display: flex;

    button {
      padding: ${({ theme }) => `${theme.space.xxs} ${theme.space.lg}`};
      svg {
        font-size: 16px;
      }
    }

    ${StyledButton} {
      margin-right: ${({ theme }) => theme.space.sm};
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;

    .btns {
      justify-content: space-between;
      display: flex;
      margin-bottom: ${({ theme }) => theme.space.md};
      flex: 1 1 0px;

      button {
        padding: ${({ theme }) => `${theme.space.xs} ${theme.space.lg}`};
      }

      ${StyledButton} {
        margin-right: ${({ theme }) => theme.space.xxs};
      }
    }
  }
`
